import React, { useState } from 'react';
import { loginWithEmail, loginWithGoogle } from '../services/auth';
import { useNavigate, Link } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import '../styles/Auth.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (setter) => (e) => {
    setError('');
    setter(e.target.value);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await loginWithEmail(email, password);
      navigate('/taskBoard');
    } catch (err) {
      if (err.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (err.code === 'auth/wrong-password') {
        setError('Incorrect password. Please try again.');
      } else if (err.code === 'auth/invalid-credential' || err.code === 'auth/invalid-login-credentials') {
        setError('Incorrect email or password.');
      } else {
        setError(`Login failed: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      await loginWithGoogle();
      navigate('/taskBoard');
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setError(`Google login failed: ${err.message}`);
      }
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-welcome">
            <h1 className="auth-welcome-title">Welcome Back!</h1>
            <p className="auth-welcome-subtitle">Ready to conquer your tasks today?</p>
          </div>
          <h2 className="auth-title">Login</h2>
          <form onSubmit={handleLogin} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                data-testid="email-input"
                value={email}
                onChange={handleInputChange(setEmail)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                data-testid="password-input"
                value={password}
                onChange={handleInputChange(setPassword)}
                placeholder="Enter your password"
                required
              />
            </div>
            {error && <div className="auth-error" data-testid="error-msg">{error}</div>}
            <button type="submit" className="auth-submit-btn" data-testid="login-btn" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="auth-divider">
            <span>or</span>
          </div>

          <button onClick={handleGoogleLogin} className="google-btn" data-testid="google-btn" disabled={loading}>
            <FcGoogle style={{ fontSize: '20px' }} />
            {loading ? 'Redirecting...' : 'Continue with Google'}
          </button>

          <div className="auth-link-text">
            <span>Don't have an account? </span>
            <Link to="/register">Register here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
